"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoplayBlockedModal = AutoplayBlockedModal;
var _react = _interopRequireDefault(require("react"));
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _DialogContent = require("../../primitives/DialogContent");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function AutoplayBlockedModal() {
  var _useAutoplayError = (0, _reactSdk.useAutoplayError)(),
    error = _useAutoplayError.error,
    resetError = _useAutoplayError.resetError,
    unblockAudio = _useAutoplayError.unblockAudio;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    open: !!error,
    onOpenChange: function onOpenChange(value) {
      if (!value) {
        unblockAudio();
      }
      resetError();
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogContent.DialogContent, {
      title: "Autoplay Error",
      closeable: false,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogRow, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "md",
          children: "The browser wants us to get a confirmation for playing the Audio. Please allow audio to proceed."
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.DialogRow, {
        justify: "end",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
          variant: "primary",
          onClick: function onClick() {
            unblockAudio();
            resetError();
          },
          children: "Allow Audio"
        })
      })]
    })
  });
}